import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=6ce2b970&scoped=true&"
import script from "./DateComponent.vue?vue&type=script&lang=js&"
export * from "./DateComponent.vue?vue&type=script&lang=js&"
import style0 from "./DateComponent.vue?vue&type=style&index=0&id=6ce2b970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce2b970",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
